/**
 * Vuex module for contact delete form
 */
import debug from 'debug'

const dbg = debug('store:contacts:DeleteForm:')

const actions = {
  open ({ commit }, contact) {
    dbg('Open delete form dialog')
    if (process.env.NODE_ENV === 'test') {
      return true
    }
    commit('OPEN_DIALOG', contact)
  },
  close ({ commit }) {
    dbg('Close delete form dialog')
    if (process.env.NODE_ENV === 'test') {
      return true
    }
    commit('CLOSE_DIALOG')
  },
  setContact ({ commit }, contact) {
    commit('SET_TAG', contact)
  }
}

const mutations = {
  CLOSE_DIALOG (state) {
    state.contact = null
    state.isPersonal = false
    state.dialog = false
  },

  OPEN_DIALOG (state, contact) {
    state.dialog = true
    state.contact = contact
    state.isPersonal = contact.isPersonal
  },

  SET_CONTACT (state, contact) {
    state.contact = contact
  }
}

const state = {
  dialog: false,
  contact: null,
  isPersonal: false
}

const getters = {
  dialog: state => state.dialog,
  contact: state => state.contact,
  isPersonal: state => state.isPersonal
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
